/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Account_Switch_To_SignupInputs */

const en_funnel_account_switch_to_signup = /** @type {(inputs: Funnel_Account_Switch_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new account instead`)
};

const es_funnel_account_switch_to_signup = /** @type {(inputs: Funnel_Account_Switch_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una cuenta nueva en su lugar`)
};

/**
* | output |
* | --- |
* | "Create a new account instead" |
*
* @param {Funnel_Account_Switch_To_SignupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_account_switch_to_signup = /** @type {((inputs?: Funnel_Account_Switch_To_SignupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Account_Switch_To_SignupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_account_switch_to_signup(inputs)
	return en_funnel_account_switch_to_signup(inputs)
});